<div class="user-pro-wrap">
  <div class="user-profile-thumb">
    <div class="avatar-wrapper">
      <app-doenkids-image [mediaItem]="( mediaItem$ | async )" (click)="navigateToProfile()" [defaultPlaceHolder]="avatarPlaceholder$ | async"></app-doenkids-image>
    </div>
    <div class="name">{{( emailAddress$ | async )}}</div>
  </div>
</div>
